import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InAppCampaignHostComponent } from './in-app-campaign-host.component';
import { InAppCampaignModalComponent } from './in-app-campaign-modal.component';

/**
 * Declares + exports both the host (mounted once in `layouts/full`) and the modal itself (also
 * reused, wrapped in `[preview]` mode, by the super-admin console's live preview in PR4b).
 */
@NgModule({
  declarations: [InAppCampaignModalComponent, InAppCampaignHostComponent],
  imports: [CommonModule, TranslateModule],
  exports: [InAppCampaignModalComponent, InAppCampaignHostComponent],
})
export class InAppCampaignModalModule {}
